import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import videojs from 'video.js';
import Player from "video.js/dist/video.js";
//import 'video.js/dist/video-js.css'; I don't know if this needs to be replaced with something, but it was causing problems as-is
import { Options, Source } from "../data/video-js-options";


@Component({
  selector: 'app-vjs-player',
  template: `


    <video #target class="video-js vjs-big-play-centered vjs-show-big-play-button-on-pause"  controls muted playsinline preload="none" style="box-shadow: 5px 5px 5px #888888;"></video>

  `,
  styleUrls: [
    './vjs-player.component.css'
  ],
  encapsulation: ViewEncapsulation.None,
})

export class VjsPlayerComponent implements OnInit, OnDestroy {
  @ViewChild('target', { static: true }) target: ElementRef;
  @Output() onVideoLoadStarted: EventEmitter<string> = new EventEmitter<string>();
  // See options: https://videojs.com/guides/options
  @Input() options: Options;

  player: Player;
  players: Player[];

  constructor(
    private elementRef: ElementRef,
  ) { }

  // Instantiate a Video.js player OnInit
  ngOnInit() {
    // console.log(this.target.nativeElement);
    var thisComponent = this;
    // console.log(this.options);
    this.player = videojs(this.target.nativeElement, this.options, function onPlayerReady() {
      // console.log('onPlayerReady', this);
      var controlBar = this.getChild('ControlBar');
      this.removeChild(controlBar);
      this.addChild('fullscreenToggle');
    });
    this.player.on("play", function playWasCalled() {
      thisComponent.onVideoLoadStarted.emit(this.id());
    });
  }





  // Dispose the player OnDestroy
  ngOnDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }
}

